module.exports = __webpack_public_path__ + "static/media/q-Quartile.64cd95c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/q-Quartile.png
// module id = 180
// module chunks = 0